import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, ChevronRightIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Por qué nosotros',
    href: '#valor'
  }, {
    name: 'Proceso',
    href: '#proceso'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'glass-panel py-4' : 'bg-transparent py-6'}`} data-id="element-99">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-100">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-101">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-cyan to-brand-blue flex items-center justify-center text-white font-bold text-xl shadow-[0_0_15px_rgba(0,212,255,0.5)] group-hover:shadow-[0_0_25px_rgba(0,212,255,0.8)] transition-all duration-300" data-id="element-102">
            N
          </div>
          <span className="text-xl font-bold tracking-tight text-white" data-id="element-103">
            Northvanta
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-104">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group" data-id="element-105">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-cyan transition-all duration-300 group-hover:w-full" data-id="element-106"></span>
            </a>)}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:block" data-id="element-107">
          <a href="#contacto" className="relative inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white transition-all duration-200 bg-brand-dark border border-brand-cyan/30 rounded-full hover:bg-brand-cyan/10 hover:border-brand-cyan hover:shadow-[0_0_20px_rgba(0,212,255,0.3)] overflow-hidden group" data-id="element-108">
            <span className="relative z-10 flex items-center gap-2" data-id="element-109">
              Empezar ahora
              <ChevronRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-110" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-brand-cyan/0 via-brand-cyan/10 to-brand-cyan/0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-111"></div>
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-gray-300 hover:text-white transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-112">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-113" /> : <MenuIcon className="w-6 h-6" data-id="element-114" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-115">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="absolute top-full left-0 right-0 glass-panel border-t border-white/5 py-4 px-6 flex flex-col gap-4 md:hidden" data-id="element-116">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-gray-300 hover:text-white py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-117">
                {link.name}
              </a>)}
            <a href="#contacto" className="mt-4 flex items-center justify-center w-full px-6 py-3 text-sm font-medium text-white bg-gradient-to-r from-brand-blue to-brand-cyan rounded-lg shadow-[0_0_15px_rgba(0,212,255,0.4)]" onClick={() => setMobileMenuOpen(false)} data-id="element-118">
              Empezar ahora
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}